import * as React from 'react';
import { DRAWER_WIDTH } from '@preview/constants';

type DrawerContextType = {
  drawerWidth: number;
  isDrawerOpen: boolean;
  setDrawerOpen: (open: boolean) => void;
};

export const DrawerContext = React.createContext<DrawerContextType>({
  isDrawerOpen: false,
  setDrawerOpen: () => {
    // no-op function
  },
  drawerWidth: DRAWER_WIDTH,
});

export const useDrawer = () => React.useContext(DrawerContext);

type DrawerProviderProps = {
  children: React.ReactNode;
};

export const DrawerProvider: React.FC<DrawerProviderProps> = ({ children }) => {
  const [isDrawerOpen, setDrawerOpen] = React.useState(false);

  const value = React.useMemo(
    () => ({
      isDrawerOpen,
      setDrawerOpen,
      drawerWidth: DRAWER_WIDTH,
    }),
    [isDrawerOpen]
  );

  return <DrawerContext.Provider value={value}>{children}</DrawerContext.Provider>;
};
